import React, { useContext, useEffect, createRef, useState } from 'react'
import './Sidebar.css'
import logo from '../asset/image/Logo-Lifelink.png'
import { NavLink, useLocation } from 'react-router-dom'
import { TopbarContext } from './TopbarContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LanguageContext } from '../Language/LanguageContext'
import { RoleContext } from '../Role/RoleContext'
import { RepairContext } from '../Repair/RepairContext'
import { NotifyContext, convertToSimply } from '../Library'
import { countAdmin } from '../Network/Notification'
import { isDevelopment } from '../Network/Config'
import { 
    faHome, 
    faUser, 
    faEnvelope, 
    faNewspaper,
    faCalendar,
    faImage,
    faHandPaper,
    faPhone,
    faComments,
    faInfoCircle,
    faWrench,
    faBars,
    faBuilding,
    faLock,
    faScroll,
    faTools,
    faUserCog,
    faHouseUser,
    faCalendarCheck,
    faWalking,
    faWindowMaximize,
    faBox,
    faLayerGroup,
    faBook,
    faBookReader,
    faClipboardList,
    faChartLine
} 
    from '@fortawesome/free-solid-svg-icons'
import packageJson from '../../package.json'
import Ping from '../asset/sound/ping.wav'

const sidebarRef = createRef()

function Sidebar(props) {
    const repair = useContext(RepairContext)
    const notifyCx = useContext(NotifyContext)
    const role = useContext(RoleContext)
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.sidebar;
    const prefixAuthority = "_MENU_"

    var autoInterval
    const autoUpdate = 10
    const [newTask, setNewTask] = useState(0)
    const [adminCount, setAdminCount] = useState(0)
    const [newRental, setNewRental] = useState(0)

    const playSound = () =>{
        const audio = new Audio(Ping)
        audio.play()
    }

    const fetchNotificationCount = (first) =>{
        countAdmin(
            (data)=>{
                if(role.checkPermission(prefixAuthority, "app.my_task_list")){
                    setNewTask(data.new_task)
                    setNewRental(data.new_rental)
                    let currentTask = parseInt(localStorage.getItem("task_count"))
                    if((data.new_task > currentTask) && !first){
                        notifyCx.showNotify(langCx.lang.repair_service.new_task, langCx.lang.repair_service.new_task_desc, 1)
                        playSound()
                    }

                    localStorage.setItem("task_count", data.new_task)
                }
                if(localStorage.getItem("is_super_admin") === "true"){
                    setAdminCount(data.administration_count)
                    localStorage.setItem("admin_count", data.administration_count)
                }

            },
            (error)=>{ }
        )
    }
    
    useEffect(()=>{
        if(role.checkPermission(prefixAuthority, "app.my_task_list")){
            // repair.fetchTask()
            // repair.autoFetchTask()
        }

        fetchNotificationCount(true)
        autoInterval = setInterval(()=>{
            fetchNotificationCount(false)
        }, autoUpdate * 1000)

        const clickOutside = (e) =>{
            if(!sidebarRef?.current.contains(e.target)){
                props.onClickOutside()
            }
        }
        document.addEventListener('mousedown', clickOutside, false)
        
        return(()=>{
            //repair.clearAutoFetchTask()
            clearInterval(autoInterval)
            document.removeEventListener('mousedown', clickOutside, false)
        })
    }, [])

    return (
        <div id="sidebar" style={props.style} ref={sidebarRef}>
            <div style={{width: 250}}>
                <div className="sidebar-header">
                    <div className="sidebar-toggle d-flex d-md-none" onClick={()=>props.onToggleClose()}>
                        <FontAwesomeIcon icon={faBars}/>
                    </div>
                    <img src={logo} className="main-logo"/>
                    
                </div>
                { isDevelopment ?
                <div style={{textAlign: 'center', color: 'red'}}>
                    <b>Under Development</b><br/>
                    Do not use for commercial !
                </div>
                : null
                }
                <div className="item-container">
                    <SidebarItem to="/" title={lang.home} icon={faHome} isShow={true}/>
                    <SidebarItem to="/administration" title={lang.administration} icon={faUserCog} notificationCount={adminCount} isShow={localStorage.getItem("is_super_admin") === "true" ? true:false}/>
                    <SidebarItem to="/repair" title={lang.repair_task} icon={faTools} notificationCount={convertToSimply(newTask)} isShow={role.checkPermission(prefixAuthority, "app.my_task_list")}/>
                    <SidebarItem to="/listspare" title={lang.list_spare} icon={faClipboardList} isShow={role.checkPermission(prefixAuthority, "app.my_task_list")}/>
                    <SidebarItem to="/service" title={lang.repair_service} icon={faWrench} isShow={role.checkPermission(prefixAuthority, "app.service_inform")}/>
                    <SidebarItem to="/user" title={lang.user} icon={faUser} isShow={role.checkPermission(prefixAuthority, "page.user")}/>
                    <SidebarItem to="/role" title={lang.role} icon={faLock} isShow={role.checkPermission(prefixAuthority, "app.role")}/>
                    <SidebarItem to="/floor" title={lang.floor} icon={faLayerGroup} isShow={role.checkPermission(prefixAuthority, "app.company_list")}/>
                    <SidebarItem to="/company" title={lang.company} icon={faBuilding} isShow={role.checkPermission(prefixAuthority, "app.company_list")}/>
                    <SidebarItem to="/booking" title={lang.booking} icon={faCalendarCheck} isShow={role.checkPermission(prefixAuthority, "page.admin_booking")}/>
                    <SidebarItem to="/rental" title={lang.tenant} icon={faHouseUser} notificationCount={newRental} isShow={role.checkPermission(prefixAuthority, "app.admin_rental")} />
                    <SidebarItem to="/inbox" title={lang.inbox} icon={faEnvelope} isShow={role.checkPermission(prefixAuthority, "app.inbox_send")}/>
                    <SidebarItem to="/delivery" title={lang.delivery} icon={faBox} isShow={role.checkPermission(prefixAuthority, "app.admin_linkservice_delivery")}/>
                    <SidebarItem to="/visitor" title={lang.visitor} icon={faWalking} isShow={role.userRole != 'User'? role.checkPermission(prefixAuthority, "app.admin_visitor"): false}/>
                    <SidebarItem to="/linkroom" title={lang.linkroom} icon={faBookReader} isShow={role.checkPermission(prefixAuthority, "app.linkroom")}/>
                    {/* <SidebarItem to="/front-screen" title={lang.front_screen} icon={faWindowMaximize} isShow={role.checkPermission("_MENU_", "app.front_screen")}/> */}
                    <SidebarItem to="/news" title={lang.news} icon={faNewspaper} isShow={role.checkPermission(prefixAuthority, "app.news_list")}/>
                    <SidebarItem to="/gallery" title={lang.gallery} icon={faImage} isShow={role.checkPermission(prefixAuthority, "app.album")}/>
                    {/*<SidebarItem to="/calendar" title={lang.calendar} icon={faCalendar} isShow={role.checkPermission(prefixAuthority, "app.calendar")}/>*/}
                    {/* <SidebarItem to="/term" title={lang.term} icon={faHandPaper} isShow={role.checkPermission(prefixAuthority, "app.terms")}/> */}
                    <SidebarItem to="/contact" title={lang.contact} icon={faPhone} isShow={role.checkPermission(prefixAuthority, "app.contact")}/>
                    <SidebarItem to="/faq" title={lang.faq} icon={faComments} isShow={role.checkPermission(prefixAuthority, "app.faq_list")}/>
                    <SidebarItem to="/aboutus" title={lang.about_us} icon={faInfoCircle} isShow={role.checkPermission(prefixAuthority, "app.about_us")}/>
                    <SidebarItem to="/log" title={lang.activity_log} icon={faScroll} isShow={role.checkPermission(prefixAuthority, "app.activity_log")}/>
                    {/* <SidebarItem to="/visitors" link="/visitors" title={lang.vsm} icon={faBook} isShow={role.checkPermission(prefixAuthority, "app.activity_log")}/> */}
                    
                    <SidebarItem to="/monitor" title={lang.monitor} icon={faChartLine} isShow={true}/>
                    <div className="version-web">
                        <div>{lang.version} : {packageJson.version}</div>
                        <div>© LifelinkTech</div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

function SidebarItem(props){
    const topbarCx = useContext(TopbarContext)
    const location = useLocation()
    // console.log(props.onclick)
    useEffect(()=>{
        if(location.pathname.startsWith(props.to)){
            topbarCx.setTopTitle(props.title)
        }
    },[])

    return(
        <NavLink 
        to={props.to}
        className="sidebar-item"
        activeClassName="sidebar-item-active"
        onClick={()=>{
            topbarCx.setSidebar(false)
            topbarCx.setTopTitle(props.title)
            if(props.link == '/visitors'){
                window.location.href = 'https://visitor.lifelink.co.th/'
            }
            /*else if(props.link == '/linkroom'){
                window.location.href = 'https://linkroom.admin.lifelink.co.th/'
            }*/
        }}
        exact={props.to === "/" ? true: false}
        style={{display: props.isShow ? "flex": "none"}}
        >
            <div>
            <FontAwesomeIcon icon={props.icon} className="sidebar-icon"/>
            {props.title}
            </div>
            { props.notificationCount > 0 ?
            <div className="notification">
                {convertToSimply(props.notificationCount)}
            </div> : null
            }
        </NavLink>
    )
}

export { Sidebar }
